import sumBy from 'lodash/sumBy'
import moment from 'moment'
import {STATUSES} from '@/store/constants'

export default {
  state: {},
  getters: {
    totalAppointments (state, getters) {
      return getters.activeAppointments.length
    },
    totalMonetaryValue (state, getters) {
      // return getters.activeAppointments.length
      return sumBy(getters.activeAppointments, function (o) { return parseFloat(o.price) })
    },
    totalPaidMonetaryValue (state, getters) {
      let paidAppointments = getters.activeAppointments.filter(function (item) {
        return item.status.toLowerCase() === 'p'
      })
      return sumBy(paidAppointments, function (o) { return parseFloat(o.price) })
    },
    totalMoneyOutstanding (state, getters) {
      return getters.totalMonetaryValue - getters.totalPaidMonetaryValue
    },
    appointmentsOverTime (state, getters) {
      // let firstDay = moment(getters.activeAppointments[0].start_time)
      // let lastDay = moment(getters.activeAppointments[getters.activeAppointments.length - 1].start_time)
      let firstDay = moment(getters.activeDateRange.from)
      let lastDay = moment(getters.activeDateRange.to)
      let data = []
      let labels = []

      let currentDate = firstDay
      while (currentDate <= lastDay) {
        let formattedDate = currentDate.format('YYYY-MM-DD')
        // currentDate's appointments:
        let currentDateAppointments = getters.activeAppointments
          .filter(function (item) {
            if (item && item.start_time) {
              return item.start_time.split('T')[0] === formattedDate
            }
          })
        data.push(currentDateAppointments.length)
        labels.push(formattedDate)
        currentDate = currentDate.add(1, 'days')
      }
      return {
        labels: labels,
        data: data
      }
    },
    stackedAppointmentsOverTime (state, getters) {
      let counts = {}
      let statusKeys = Object.keys(STATUSES)
      statusKeys.map((key) => { counts[key] = {} })
      let currentDay = null
      for (let appt of getters.activeAppointments) {
        if (appt && appt.start_time) {
          let day = appt.start_time.split('T')[0]
          if (day !== currentDay) {
            for (let k of statusKeys) {
              counts[k][day] = 0
            }
          }
          counts[appt.status][day] = (counts[appt.status][day] + 1)
          currentDay = day
        }
      }
      let labels = Object.keys(counts['B'])
      let datas = []
      for (let k of statusKeys) {
        let data = counts[k]
        datas.push({
          label: STATUSES[k].title,
          backgroundColor: STATUSES[k].color,
          borderColor: '#000',
          lineTension: 0,
          pointRadius: 1,
          borderWidth: 1,
          legend: {
            display: false
          },
          title: 'Appointments by status over time',
          data: Object.values(data)
        })
      }
      return {
        labels: labels,
        datasets: datas
      }
    },
    appointmentsByDay (state, getters) {
      /* Summary of the count of appointments per weekday */
      let labels = ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat']
      let data = [0, 0, 0, 0, 0, 0, 0]
      for (let appointment of getters.activeAppointments) {
        let day = moment(appointment.start_time).day()
        data[day] = data[day] + 1
      }
      return {
        labels: labels,
        data: data
      }
    },
    appointmentsByHour (state, getters) {
      /* Summary of the count of appointments per hour of the day */
      let labels = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23]
      let data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      for (let appointment of getters.activeAppointments) {
        let hour = moment(appointment.start_time).hour()
        data[hour] = data[hour] + 1
      }
      return {
        labels: labels,
        data: data
      }
    },
    productTypeBreakdown (state, getters) {
      let products = []
      getters.services.map((service) => { products = products.concat(service.products) })
      let labels = products.map((product) => { return product.title })
      let productIds = products.map((product) => { return product.id })
      let data = Array.from(Array(labels.length), () => 0)
      for (let appointment of getters.activeAppointments) {
        let index = productIds.indexOf(appointment.product)
        data[index] = data[index] + 1
      }

      return {
        labels: labels,
        data: data
      }
    },
    statusBreakdown (state, getters) {
      // first flatten status into map
      let results = {}
      for (let appointment of getters.appointments) {
        if (!results[appointment.status]) {
          results[appointment.status] = 0
        }
        results[appointment.status] = results[appointment.status] + 1
      }
      // then format into label and data arrays
      let keys = Object.keys(STATUSES)
      let labels = Object.values(STATUSES).map((item) => { return item.title })
      let data = []
      for (let key of keys) {
        let res = results[key]
        if (!res) { res = 0 }
        data.push(res)
      }
      return {
        labels: labels,
        data: data
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/charts.js